import { apiConstants } from "@data/constants/apiConstants"
import { authConstants } from "@data/constants/authConstants"
import { authService } from "@data/services/authService"
import { brevetFunnelService } from "../../../../brevet/services/brevetFunnelService"

const initialState = {
    // Funnel state persisted server-side under this id (pre-auth lead capture).
    funnelStateId: null,
    // user pre-created par le start endpoint (utile pour reprendre/identifier le lead).
    userId: null,
    // Pré-rempli renvoyé par /init (HubSpot hydration) — firstname/email/student_class.
    // Le screen Step1 pioche dedans pour hydrater son Context React au mount.
    initUser: null,
    // Snapshot du dernier GET /brevet-funnel/{id} si on le récupère (deep link reprise).
    serverState: null,
}

export function brevetFunnel(state = initialState, action) {
    switch (action.type) {
        case brevetFunnelService.startFunnel.name + apiConstants._SUCCESS: {
            const payload = action.data || {}
            return {
                ...state,
                funnelStateId:
                    payload.funnel_state_id ??
                    payload.funnelStateId ??
                    state.funnelStateId,
                userId: payload.user_id ?? payload.userId ?? state.userId,
            }
        }

        case brevetFunnelService.initFromHubSpot.name + apiConstants._SUCCESS: {
            // /init lands the same funnelStateId + a `user` object pre-filled from
            // the HubSpot submission. The screen reads initUser via mapStateToProps
            // and pushes its fields into the React Context on the next render.
            const payload = action.data || {}
            return {
                ...state,
                funnelStateId:
                    payload.funnel_state_id ??
                    payload.funnelStateId ??
                    state.funnelStateId,
                initUser: payload.user ?? state.initUser,
            }
        }

        case brevetFunnelService.getFunnelState.name + apiConstants._SUCCESS: {
            const payload = action.data || {}
            return {
                ...state,
                serverState: payload,
            }
        }

        // Reset on logout — required for any user-scoped data
        case authConstants.LOGOUT_401:
        case authConstants.RESET_AUTH_STATE:
        case authService.logout.name + apiConstants._SUCCESS:
            return initialState

        default:
            return state
    }
}

export default brevetFunnel
